/**
 * The onboarding context and its only reader.
 *
 * Separate from `OnboardingProvider.tsx` because that file exports a component:
 * a module that exports both a component and a hook breaks fast refresh. The
 * alternative — keeping them together behind a lint suppression — trades a real
 * developer-loop regression for one fewer file.
 */
import { createContext, useContext } from "react";

import type { OnboardingState } from "./types";

export const OnboardingContext = createContext<OnboardingState | null>(null);

/**
 * The only reader of onboarding stage. Nothing outside this section reaches for
 * `dataset_provisioning_*` or `setup.*` directly.
 */
export function useOnboarding(): OnboardingState {
  const value = useContext(OnboardingContext);
  if (value === null) {
    throw new Error("useOnboarding must be used inside OnboardingProvider");
  }
  return value;
}
